import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { PolyglotComponentProps, withPolyglot } from '../../../../../i18n';
import ListItem from '../../../../../theme/components/ListItem';
import { Group } from '../../../../../redux/groups/api/group.model';
import GroupModel from '../../../../../redux/groups/api/GroupModel';
import { RootState, useAppSelector } from '../../../../../redux/store.model';
import { groupButtonsRightsSelector } from '../../../../../redux/groups/selectors/groupRightsSelectors';
import {
  RouterComponentProps,
  withRouter,
} from '../../../../../util/route-dom';
import {
  GroupActionsGrid,
  GroupActionsList,
} from './GroupActions/GroupActions';
import { DeviceGroupIcon } from '../../../../../theme/icons';
import { getAlarmActiveBySelector } from '../../../../../redux/incident/selectors/getAlarmActiveBySelector';
import { getFeatureToggle } from '../../../../../featureToggle';
import { BusinessRole } from '../../../../../customized/fresh-watch/redux/businessModel/model/model';
import { Base64 } from '../../../../../util/Base64';

interface GroupCardProps
  extends PolyglotComponentProps,
    RouterComponentProps,
    OwnProps,
    ConnectedComponentProps {}
interface OwnProps {
  group?: Group;
  loading?: boolean;
  groupId: string;
  moduleSelected: string | '';
}

export function GroupCardSimple(props: GroupCardProps) {
  const { group, groupId, navigate, moduleSelected, loading } = props;

  const featureToggle = useAppSelector(getFeatureToggle);
  /* TODO: Update when there is a better product decision on stores list view */
  const isFreshWatch =
    featureToggle?.styledComponentsVariants === 'fresh-watch';

  const { data: alarmsActive } = useAppSelector((state) =>
    getAlarmActiveBySelector(state, {
      groupId: groupId,
    })
  );

  const openDeviceDetail = () => {
    if (moduleSelected === '') return;
    const url = `/devicemanager/group/${groupId}`;
    navigate(url);
  };

  const onNavigateToMerchandiser = () => {
    if (group?.attributes?.['BUSINESS_ROLE'] === BusinessRole.STORE) {
      let groupId = group.id;
      try {
        // Check if ID is Base64 encoded by testing if decode→encode gives the same result
        const decoded = Base64.decode(group.id);
        const reencoded = Base64.encode(decoded);
        if (reencoded === group.id) {
          // ID was Base64 encoded, use the decoded version
          groupId = decoded;
        }
        // Otherwise, ID is not Base64 encoded, use as-is
      } catch (error) {
        // If decode fails, the ID is not Base64 encoded, use as-is
        // eslint-disable-next-line no-console
        console.debug('Group ID is not Base64 encoded, using as-is');
      }
      navigate(`/merchandiser/${groupId}`);
    } else {
      navigate(`/storelist/group/${group?.id}`);
    }
  };

  return (
    <ListItem
      key={groupId}
      id={groupId}
      name={group?.name}
      loading={loading}
      iconURL={group?.iconURL}
      subtitle={!isFreshWatch && GroupModel.getGroupSubtitles(group)}
      iconNode={
        !group?.iconURL ? group?.iconNode ?? <DeviceGroupIcon /> : undefined
      }
      className={GroupModel.getClassesNamesFromDevice(group)}
      onClick={isFreshWatch ? onNavigateToMerchandiser : openDeviceDetail}
      buttons={<GroupActionsList group={group} />}
      menuButtons={<GroupActionsGrid group={group} />}
      ItemContainerProps={{ sx: { px: 2 } }}
      error={alarmsActive.length > 0}
    />
  );
}

const mapStateToProps = (
  state: RootState,
  props: OwnProps &
    RouterComponentProps<{
      groupId?: string;
    }>
) => ({
  ...groupButtonsRightsSelector(state, props),
  accessToken: state.auth.accessToken,
});

const connector = connect(mapStateToProps);

export type ConnectedComponentProps = ConnectedProps<typeof connector>;

const GroupCard = withPolyglot(withRouter(connector(GroupCardSimple)));
export default GroupCard;
